/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CancelAllOpenOrdersOptions,
  CancelAllOpenOrdersStatus200,
  CancelAllOpenOrdersStatus401,
  CancelAllOpenOrdersStatus500,
} from '../types/CancelAllOpenOrders'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { cancelAllOpenOrders } from '../clients/cancelAllOpenOrders'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const cancelAllOpenOrdersMutationKey = () => [{ url: '/v1/orders' }] as const

export function cancelAllOpenOrdersMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = cancelAllOpenOrdersMutationKey()
  return mutationOptions<
    CancelAllOpenOrdersStatus200,
    ResponseErrorConfig<CancelAllOpenOrdersStatus401 | CancelAllOpenOrdersStatus500>,
    CancelAllOpenOrdersOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ query }) => {
      return cancelAllOpenOrders({ ...config, query, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Cancel all open orders, if user passes orderbook or account_id on query params it will cancel all orders on specific orderbook or account, admin can cancel user's orders on specific orderbook
 * {@link /v1/orders}
 */
export function useCancelAllOpenOrders<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CancelAllOpenOrdersStatus200,
      ResponseErrorConfig<CancelAllOpenOrdersStatus401 | CancelAllOpenOrdersStatus500>,
      CancelAllOpenOrdersOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? cancelAllOpenOrdersMutationKey()

  const baseOptions = cancelAllOpenOrdersMutationOptions(config) as UseMutationOptions<
    CancelAllOpenOrdersStatus200,
    ResponseErrorConfig<CancelAllOpenOrdersStatus401 | CancelAllOpenOrdersStatus500>,
    CancelAllOpenOrdersOptions,
    TContext
  >

  return useMutation<
    CancelAllOpenOrdersStatus200,
    ResponseErrorConfig<CancelAllOpenOrdersStatus401 | CancelAllOpenOrdersStatus500>,
    CancelAllOpenOrdersOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CancelAllOpenOrdersStatus200,
    ResponseErrorConfig<CancelAllOpenOrdersStatus401 | CancelAllOpenOrdersStatus500>,
    CancelAllOpenOrdersOptions,
    TContext
  >
}
